export default __webpack_public_path__ + "static/media/clearCards.9a161aee.mp3";